import type { ReactElement } from 'react';

/**
 * The envelope — Ember's letter to the person (§4.9). Sealed: the flap down,
 * the amber seal on it (the Result's stamp colour: the same hand). Opened:
 * the flap up, the seal broken, the paper showing. Drawn in a 40×28 box so
 * the same shapes sit in an HTML glyph (rows, the chat's door line) and in
 * the tree's SVG (at the figure's feet).
 */
export function LetterShapes({ sealed }: { sealed: boolean }): ReactElement {
  return sealed ? (
    <>
      <rect x="1" y="1" width="38" height="26" rx="3" fill="#f4e8d2" stroke="#c9b48e" strokeWidth="1" />
      <path d="M1.5 3 L20 16 L38.5 3" fill="none" stroke="#c9b48e" strokeWidth="1.2" strokeLinejoin="round" />
      <circle cx="20" cy="15.5" r="4.2" fill="#b8772a" />
      <path d="M20 12.6c.4 1.6 1.9 2.1 1.9 4a1.9 1.9 0 0 1-3.8 0c0-1 .5-1.6.8-2.1 0 .8.3 1.3.8 1.3 0-1.3 0-2.3.3-3.2z" fill="#f6b352" />
    </>
  ) : (
    <>
      <rect x="1" y="7" width="38" height="20" rx="3" fill="#f4e8d2" stroke="#c9b48e" strokeWidth="1" />
      <path d="M5 7 L20 -1 L35 7" fill="#efe1c6" stroke="#c9b48e" strokeWidth="1" strokeLinejoin="round" />
      <path d="M1.5 9 L20 21 L38.5 9" fill="none" stroke="#c9b48e" strokeWidth="1.2" strokeLinejoin="round" />
    </>
  );
}

export function LetterGlyph({ sealed, size = 30, className = '' }: { sealed: boolean; size?: number; className?: string }): ReactElement {
  return (
    <svg className={className} viewBox="-1 -3 42 32" width={size} height={Math.round(size * 0.76)} aria-hidden>
      <LetterShapes sealed={sealed} />
    </svg>
  );
}
